<template>
	<div class="body-container" @click="closeSelectExpand">
		<headerNavigation ref="headerRef" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer" style="height: 115px;"></div>
		</template>
		<div class="site-main-container">
			<div class="flow-checkout-container container" :class="isEmpty ? 'page-cart-container-v3' : 'page-cart-container'">
				<div class="page-title-container row">
					<div :class="isEmpty ? '' : 'col-md-12'"><h1 class="page-title">{{$t('cart.shoppingcart')}}</h1></div>
					<!-- <div class="col-md-12 hidden-xs hidden-sm" v-if="isEmpty">
						<div class="flow-action-button-container top-cart-page row">
							<button class="checkout-btn site-btn-primary">{{$t('cart.checkoutnow')}}</button>
						</div>
					</div> -->
				</div>
				<div class="cart-container empty-cart" v-if="!isLogin || isEmpty">
					<div class="content-container">
						<div class="cart-content-container col-24">
							<div class="empty-cart-container">
								<h2>{{$t('cart.cartempty')}}</h2>
								<p class="empty-cart-message" v-if="!isLogin">{{$t('cart.cartnotlogin')}}</p>
								<div class="empty-cart-btn-container" v-if="!isLogin">
									<button type="button" @click="openLoginMadal" class="empty-cart-btn site-btn-primary-semi-bold">{{$t('common.login2')}}</button>
								</div>
								<div class="empty-cart-btn-container" v-else>
									<button type="button" @click="openPage('/')" class="empty-cart-btn site-btn-primary-semi-bold">{{$t('cart.continueshopping')}}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-else>
					<div class="cart-content-container col-md-24">
						<div class="row">
							<div class="cart-items-container col-md-24" v-for="(item,index) in cartData" :key="index">
								<div class="comp-cart-item-container" >
									<div class="item-header-container row" v-if="isMobile">
										<div class="hidden-md hidden-lg project-name-container col-xs-6">
											<span class="site-paragraph-title-bold item-price">{{$t('cart.productdetail')}}</span>
										</div>
										<div class="hidden-md hidden-lg item-price-container col-xs-18" style="float: right;">
											<span class="site-paragraph-title-bold item-price" v-if="lang == 'zh'"> {{item.unitPrice}} 美元</span>
											<span class="site-paragraph-title-bold item-price" v-else> ${{item.unitPrice}}</span>
										</div>
									</div>
									<div class="item-data-container row">
										<div class="item-preview-container col-md-5" :class="isMobile ? 'has-switch' : ''">
											<div class="comp-cart-item-file-preview-container">
												<div class="item-preview-details-container" @click="openPage('/product?no='+item.productNo)">
													<img :src="item.productImg" class="product-thumbs"/>
												</div>
											</div>
										</div>
										<div class="item-container col-md-18 col-lg-19">
											<div class="item-table-grid">
												<div class="item-information-container row">
													<div class="item-details-container item-container col-md-15">
														<div class="comp-cart-item-specs-container">
															<div class="item-name-container">
																<p class="site-paragraph-title-bold product-name-text">{{item.productName}}</p>
															</div>
															<div class="row">
																<ul class="col-xs-24 specs-list-group dynamic-specs-list-group col-md-12">
																	<li class="7 item-spec hidden-sm" v-for="(attribute,aindex) in item.parsedSkuAttrs">
																		<span class="site-paragraph-title-bold spec-name">{{attribute.key}}</span>：
																		<span>{{attribute.value}}</span>
																	</li>
																	<!-- <li class="item-spec hidden-md hidden-lg additional-spec show" v-if="isMobile">
																		<span class="site-paragraph-title-bold spec-name">{{$t('common.quantity')}}</span>：
																		<a href="javascript:void(0)" class="site-secondary-link-italic"> 1,000 </a>
																	</li> -->
																	<li class="4 item-spec hidden-sm" v-if="isMobile">
																		<div class="p-quantity-wrapper" style="float: left;">
																			<div class="p-quantity-block">
																				<input type="button" value="-" class="minus btn" @click.stop="decNum(index,item.id)">
																				<input type="number" v-model="item.productNum" class="input-text qty text" min="0" step="1" inputmode="numeric" autocomplete="off">
																				<input type="button" value="+" class="plus btn" @click.stop="plusNum(index,item.id)">
																			</div>
																		</div>
																	</li>
																	<li class="4 item-spec hidden-sm" v-if="item.fileurllist.length > 0">
																		<div class="cart-design-img-wrapper">
																			<el-image :src="imgs"  :preview-src-list="item.fileurllist" class="d-imgs" v-for="(imgs,mindex) in item.fileurllist" :key="mindex"></el-image>
																		</div>
																	</li>
																</ul>
																<ul class="specs-list-group col-xs-24 col-md-12 hidden-sm hidden-xs">
																	<!-- <li class="item-spec">
																		<span class="site-paragraph-title-bold spec-name">{{$t('common.quantity')}}：</span>
																		<a class="site-secondary-link-italic">1,000</a>
																	</li> -->
																	<!-- <li class="item-spec">
																		<span class="site-paragraph-title-bold spec-name">{{$t('product.printingtime')}}：</span>
																		<a class="site-secondary-link-italic">3个工作日</a>
																	</li> -->
																	<li class="item-spec">
																		<div class="p-quantity-wrapper" style="float: left;">
																			<div class="p-quantity-block">
																				<input type="button" value="-" class="minus btn" @click.stop="decNum(index,item.id)">
																				<input type="number" v-model="item.productNum" class="input-text qty text" min="0" step="1" inputmode="numeric" autocomplete="off">
																				<input type="button" value="+" class="plus btn" @click.stop="plusNum(index,item.id)">
																			</div>
																		</div>
																	</li>
																</ul>
															</div>
														</div>
													</div>
													<div class="hidden-xs hidden-sm col-item-links-container item-container col-md-5">
														<ul class="item-links-container">
															<li class="remove-item-action-container">
																<el-popconfirm :title="$t('tips.confirmdel')" @confirm="delCartItem(index,item.id)">
																	<span slot="reference" class="delete-item-link" >
																		<img src="../../assets/images/del.png" class="del-icon"/>
																		<span class="site-secondary-link-italic item-action-label">{{$t('cart.delitem')}}</span>
																	</span>
																</el-popconfirm>
															</li>
														</ul>
													</div>
													<div class="price-links-container item-container hidden-xs hidden-sm col-md-4">
														<div class="item-price-container">
															<span class="site-paragraph-title-bold item-price" v-if="lang == 'zh'">{{item.unitPrice}} 美元</span>
															<span class="site-paragraph-title-bold item-price" v-else>${{item.unitPrice}}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="hidden-md hidden-lg bottom-action-buttons" v-if="isMobile">
										<ul class="item-links-container">
											<li class="remove-item-action-container">
												<el-popconfirm :title="$t('tips.confirmdel')" @confirm="delCartItem(index,item.id)">
													 <span class="delete-item-link">
														<img src="../../assets/images/del.png" class="del-icon"/>
														<span class="site-secondary-link-italic item-action-label">{{$t('common.delete')}}</span>
													 </span>
												</el-popconfirm>
												
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="subtotal-and-buttons-container">
							<div class="row subtotal-row subtotal-container">
								<div class="col-md-12 hidden-sm hidden-xs"></div>
								<div class="col-md-12 bottom-right-section">
									<h4 class="subtotal-label">
										{{$t('cart.subtotal')}}
										<span class="subtotal-value-container">
											<span class="subtotal-value" v-if="lang == 'zh'">{{cartPrice}} 美元</span>
											<span class="subtotal-value" v-else>${{cartPrice}}</span>
										</span>
									</h4>
								</div>
							</div>
							<div class="row cart-cta-btns-row">
								<div class="col-md-12 hidden-sm hidden-xs">
									<div class="row">
										<div class="col-md-24">
											<button class="continue-shopping-btn site-btn-tertiary" @click="openPage('/')">{{$t('cart.continueshopping')}}</button>
										</div>
										<div class="col-md-22">
											<!-- <span class="coupon-toggle-link" @click="changeCouponCollapsed">
												<span>{{$t('cart.havecoupon')}}</span>
												<img src="../../assets/images/arrow-down.png" class="down-icon"/>
											</span>
											<div class="site-panel coupon-section-panel" :class="useCoupon ? '' : 'hide-coupon-section'">
												<div class="comp-coupon-section-container">
													<div class="row">
														<div class="col-md-15 col-xs-12">
															<div class="coupon-input-group site-form-group">
																<div class="site-input-group">
																	<input type="text" :placeholder="$t('tips.pleaseinputcoupon')"  maxlength="50" class="site-form-input name-input form-control">
																</div>
															</div>
														</div>
														<div class="col-md-9 col-xs-12">
															<button class="site-btn-secondary apply-coupon-btn">
																<span class="apply-coupon-label">{{$t('cart.usecoupon')}}</span>
															</button>
														</div>
													</div>
												</div>
											</div> -->
										</div>
									</div>
								</div>
								<div class="col-md-12 bottom-right-section">
									<div class="checkout-btn-wrap shrink">
										<button class="checkout-btn site-btn-primary" @click="openPage('checkout')">{{$t('cart.checkoutnow')}}</button>
									</div>
									
								</div>
								<div class="col-md-12 continue-shopping-btn-wrapper visible-sm visible-xs" v-if="isMobile">
									<div>
										<button class="continue-shopping-btn site-btn-tertiary" @click="openPage('/')">{{$t('cart.continueshopping')}}</button>
									</div>
								</div>
							</div>
							<!-- <div class="coupon-section row hidden-md hidden-lg" v-if="isMobile">
								<div class="col-md-11 col-sm-24 col-xs-24 coupon-details-wrap">
									<span class="coupon-toggle-link" @click="changeCouponCollapsed">
										<span>{{$t('cart.havecoupon')}}</span>
										<img src="../../assets/images/arrow-down.png" class="down-icon"/>
									</span>
									<div class="site-panel coupon-section-panel " :class="useCoupon ? '' : 'hide-coupon-section'">
										<div class="comp-coupon-section-container">
											<div class="row">
												<div class="col-md-15 col-xs-12">
													<div class="coupon-input-group site-form-group">
														<div class="site-input-group">
															<input class="site-form-input name-input form-control" :placeholder="$t('tips.pleaseinputcoupon')"/>
														</div>
													</div>
												</div>
												<div class="col-md-9 col-xs-12">
													<button class="site-btn-secondary apply-coupon-btn">
														<span class="apply-coupon-label">{{$t('cart.use')}}</span>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="site-modal modal fade comp-edit-specs-modal-container in" style="display: block;" v-if="showModal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
					    <button class="modal-close-btn close" type="button" @click="closeModal">
					        <span>×</span>
					    </button>
					    <h4 class="modal-title">{{$t('common.edit')}}</h4>
					</div>
					<div class="modal-body">
						<div class="modal-content-container calculator-container">
							<div class="calc-wrapper">
								<div class="calc-instance">
									<div class="calculator">
										<div class="calc-group">
											<div class="standard-section">
												<div>
													<div class="calc-attr dropdown-attr-5">
														<label class="calculator-label">
															<span>{{$t('common.quantity')}}</span>：
														</label>
														<div class="attr-container  ">
															<div class="site-dropdown site-dropdown-group dropdown  ">
																<button class="btn dropdown-toggle val-wrap " @click.stop="changeSelectExpand">
																	<span class="dropdown-toggle-label">1,000</span>
																	<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down a-down-icon"/>
																</button>
																<ul class="dropdown-menu menu-parent" :class="openSelect ? 'ul-expand' : ''">
																	<li class="blurb-list-dropdown dropdown-menu-item">
																		<a class="attr-value val-wrap   ">
																			<span class="val">
																				<span class="dropdown-link-text">
																					<div class="badge-blurb-container">
																						<span>250</span>
																					</div>
																				</span>
																			</span>
																			
																		</a>
																	</li>
																	<li class="blurb-list-dropdown dropdown-menu-item">
																		<a class="attr-value val-wrap   ">
																			<span class="val">
																				<span class="dropdown-link-text">
																					<div class="badge-blurb-container">
																						<span>500</span>
																					</div>
																				</span>
																			</span>
																			<img src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle check-iocn"/>
																		</a>
																	</li>
																	<li class="blurb-list-dropdown dropdown-menu-item" v-for="item in 4">
																		<a class="attr-value val-wrap   ">
																			<span class="val">
																				<span class="dropdown-link-text">
																					<div class="badge-blurb-container">
																						<span>1000</span>
																					</div>
																				</span>
																			</span>
																		</a>
																	</li>
																</ul>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="printing-cost-container">
								<span class="printing-cost-label">{{$t('product.printingcost')}}</span>
								<span class="printing-cost">333.60 美元</span>
							</div>
						</div>
						<div class="action-button-container">
							<div>
								<button class="site-btn-primary js-edit-item-cta js-end-trap">
									<span>{{$('common.update')}}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<div v-if="showModal" class="modal-backdrop fade ng-scope in" style="z-index: 1040;" @click="closeModal"></div> 
		<footers></footers>
		<div class="z-block"></div>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import loading from '../../components/loading.vue'
	import {getCartList,delCart,editCartNum} from '../../api/api.js'
	
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal,
			loading
		},
		data() {
			return {
				showLoginModal:false,
				isEmpty:true,
				useCoupon:false,
				openSelect:false,
				showModal:false,
				isMobile:false,
				isLoading:false,
				cartData:[],
				cartPrice:0,
				isLogin:false,
				lang:'',
			};
		},
		mounted() {
		},
		created() {
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			this.isMobile = this.webIsMobile()
			var token = localStorage.getItem('token')
			this.isLogin = token ? true : false
			if(this.isLogin){
				this.init()
			}
		},
		methods: {
			init(){
				var that = this;
				let params = {}
				getCartList(params).then(res => {
					if (res.code == 200) {
						that.cartData = res.data.list
						that.cartPrice = res.data.totalPrice
						if(that.cartData.length > 0){
							that.isEmpty = false
						}
					}
				})
			},
			openLoginMadal(){
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal(){
				this.showLoginModal = false
			},
			changeRegister(e){
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
			changeCouponCollapsed(){
				this.useCoupon = !this.useCoupon
			},
			changeSelectExpand(){
				this.openSelect = !this.openSelect
			},
			closeSelectExpand(){
				this.openSelect = false
			},
			openModal(){
				this.showModal = true
				this.closeSelectExpand()
			},
			closeModal(){
				this.showModal = false
				this.closeSelectExpand()
			},
			delCartItem(index,id){
				var that = this;
				let params = {
					id:id
				}
				delCart(params).then(res => {
					if (res.code == 200) {
						that.calculatePrice()
						that.$refs.headerRef.queryCartQty()
						that.$message.success(res.msg);
						that.cartData.splice(index, 1);
					}else{
						that.$message.warning(res.msg);
						return false;
					}
				})
			},
			plusNum(index,cartId){
				this.cartData[index].productNum = this.cartData[index].productNum + 1
				this.confirmCartNum(cartId,this.cartData[index].productNum)
				this.calculatePrice()
			},
			decNum(index,cartId){
				if(this.cartData[index].productNum > 1){
					this.cartData[index].productNum = this.cartData[index].productNum - 1
					this.confirmCartNum(cartId,this.cartData[index].productNum)
				}
				this.calculatePrice()
			},
			confirmCartNum(cartId,num){
				var that = this;
				let params = {
					id:cartId,
					productNum:num
				}
				editCartNum(params).then(res => {
					
				})
			},
			calculatePrice(){
				var totalPrice = 0
				this.cartData.forEach((item,index) => {
					totalPrice += item.productNum * item.unitPrice
				})
				this.cartPrice = totalPrice
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/cart.css");
</style>